var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5684 1.39393C19.9826 0.808143 19.0329 0.808143 18.4471 1.39393L10.9188 8.92222L3.80642 1.80987C3.22063 1.22408 2.27088 1.22408 1.6851 1.80987C1.09931 2.39565 1.09931 3.3454 1.6851 3.93119L8.79745 11.0435L1.39393 18.4471C0.808143 19.0329 0.808143 19.9826 1.39393 20.5684C1.97972 21.1542 2.92946 21.1542 3.51525 20.5684L10.9188 13.1649L18.7382 20.9843C19.324 21.5701 20.2738 21.5701 20.8596 20.9843C21.4453 20.3985 21.4453 19.4488 20.8596 18.863L13.0401 11.0435L20.5684 3.51525C21.1542 2.92946 21.1542 1.97972 20.5684 1.39393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.3f7eb0f7c3c021c2732b795e9419b579.svg";
export { ForwardRef as ReactComponent };